// document.addEventListener("DOMContentLoaded", function() {
// // --- CONFIGURATION ---
// const BONUS_VARIANT_ID = 49658805158081; // Replace with your bonus product's VARIANT ID
// const BONUS_THRESHOLD = 75; // Threshold in dollars

// var BONUS_ADDED = false;

// // Save native fetch before xhook overrides it (important!)
// const nativeFetch = window._fetch || window.originalFetch || fetch;

// // Helper function to get updated cart
// function getCart() {
//   return nativeFetch("/cart.js").then(res => res.json());
// }

// // Helper function to add bonus product
// async function addBonusProduct() {
//   if(BONUS_ADDED) return;
//   BONUS_ADDED = true;
//   console.log("Adding bonus product…");
//    let formData = {
//     'items': [{
//         'id': 49658805158081,
//         'quantity': 1,
//         'properties': {
//             'Description': 'This Free gift includes OG, Glow State, and Blue Tongue Wizard.'
//         }
//     }]
// }
//   await window.fetch("https://www.naturesfarmersea.com/cart/add.js", {
//     method: 'POST',
//     credentials: 'same-origin',
//     headers: {
//         'Content-Type': 'application/json',
//         'X-Requested-With': 'XMLHttpRequest'
//     },
//     body: JSON.stringify(formData),
//     })
//     .then(r => r.json())
//     .then(() => { 
//         console.log("✅ Bonus product added");
//         Alpine.store('xMiniCart').reLoad();
//     });
// }

// // Helper function to remove bonus product
// function removeBonusProduct(lineItemKey) {
//   console.log("Removing bonus product…");
//   return nativeFetch("/cart/change.js", {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify({ id: lineItemKey, quantity: 0 }),
//   })
//     .then(r => r.json())
//     .then(() => { console.log("❌ Bonus product removed"); Alpine.store('xMiniCart').reLoad(); });
// }

// // Listen for any cart changes AFTER add/remove completes
// xhook.after(function (request, response) {

//   if (
//     request.url.includes("/cart/add") ||
//     request.url.includes("/cart/change") ||
//     request.url.includes("/cart/update")
//   ) {
//     console.log("xhoook loaded");
//     // Give Shopify a moment to update cart
//     setTimeout(() => {
//       getCart()
//         .then(cart => {
//           const total = cart.total_price / 100;
//           console.log("Updated cart total:", total)

//           console.log(cart.items);
//           // Find if bonus product is already in the cart
//           const bonusItem = cart.items.find(
//             item => item.variant_id === BONUS_VARIANT_ID
//           );

//           if (total > BONUS_THRESHOLD && !bonusItem) {
//             // Add bonus if above threshold and not already added
//             addBonusProduct();
//           } else if (total < BONUS_THRESHOLD && bonusItem) {
//             // Remove bonus if below threshold
//             removeBonusProduct(bonusItem.key);
//           }
//         })
//         .catch(err => console.error("Error checking cart:", err));
//     }, 20); // small delay ensures Shopify cart is updated
//   }
// });


// });

(function() {

  const bannerAmount = document.getElementById("afterpay-amount");
  if (!bannerAmount) return;
  console.log("hello");
  const priceCentsEl = document.querySelector(".main-product-price .hidden");
  if (!priceCentsEl) return;
   console.log("hello");

  function updateAfterpay() {
    const priceCents = parseInt(priceCentsEl.textContent.trim(), 10);
    if (!priceCents) return;

    const installment = Math.round(priceCents / 4);

    if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
      bannerAmount.textContent = Shopify.formatMoney(installment, "{{ shop.money_format }}");
    } else {
      bannerAmount.textContent = "$" + (installment / 100).toFixed(2);
    }
  }

  // Observe changes in the hidden price element
  const observer = new MutationObserver(updateAfterpay);
  observer.observe(priceCentsEl, {
    characterData: true,
    childList: true,
    subtree: true
  });

})();


document.addEventListener("DOMContentLoaded", function() {
  const parentEl = document.querySelector(".product-content-container"); // parent container
  if (!parentEl) return;

  let btnOffsetTop = null;

  window.addEventListener("scroll", function() {

    // Grab the button inside the parent when scroll fires
    const buyBtn = parentEl.querySelector(".shopify-payment-button__button");
    if (!buyBtn) return;
console.log(buyBtn);
    // Save original offsetTop only once
    if (btnOffsetTop === null) {
      btnOffsetTop = buyBtn.getBoundingClientRect().top + window.scrollY;
    }

    // Add/remove fixed class based on scroll
    if (window.scrollY > btnOffsetTop) {
      buyBtn.classList.add("fixed");
      document.body.appendChild(buyBtn);
    } else {
      buyBtn.classList.remove("fixed");
    }
  });
});
